<template>
    <div class="flex h-full flex-col bg-white">
        <div class="flex items-center justify-between px-8 py-4" style="background-color: #E2E8F0;">
            <div class="text-lg font-semibold uppercase text-black">
                View Detail
            </div>
            <div class="text-slate-500 transition hover:text-slate-700 cursor-pointer" @click="$emit('close')">
                <Icon icon-name="CloseIcon" />
            </div>
        </div>

        <div class="flex-1 space-y-8 bg-white py-6 overflow-y-auto min-h-0">
            <div class="flex flex-col gap-2 mb-6 px-8">
                <p class="text-sm font-bold uppercase text-slate-800">
                    Phone Number
                </p>
                <p class="text-sm text-black flex items-center gap-2">
                    <img v-if="sms.flag" :src="sms.flag" alt="country flag" class="h-6 w-6 object-contain">
                    <span v-else class="flex h-6 w-6 items-center justify-center text-xs">🏳️</span>
                    {{ sms.phone }}
                </p>
            </div>
            <div class="rounded-lg border border-slate-200 relative mx-8" v-if="sms.invoices">
                <div
                    class="absolute badge-dot inline-flex items-center bg-gray-600 border border-slate-500 px-5 py-2 text-xs font-semibold text-white">
                    <span>Invoice Details</span>
                </div>
                <table class="mt-6 min-w-full text-left border-separate px-4"
                  style="border-spacing: 0 8px;">
                    <thead class="bg-slate-100 text-xs font-semibold uppercase tracking-wide text-slate-500">
                        <tr>
                            <th class="px-5 py-3 ">Date</th>
                            <th class="px-5 py-3">Description</th>
                            <th class="px-5 py-3">Payment Method</th>
                            <th class="px-5 py-3 text-right">Total Cost</th>
                        </tr>
                    </thead>
                    <tbody class=" text-sm text-slate-600" v-if="loading">
                        <tr>
                            <td class="px-5 py-6 text-center text-sm text-slate-500" colspan="4">
                                Loading invoice details...
                            </td>
                        </tr>
                    </tbody>
                    <tbody class=" text-sm text-slate-600" v-else>
                        <tr v-for="invoice in sms.invoices" :key="invoice.id" class="bg-gray-100">
                            <td class="px-5 py-3 text-slate-700">{{ invoice.date }}</td>
                            <td class="px-5 py-3">{{ invoice.description }}</td>
                            <td class="px-5 py-3">{{ invoice.paymentMethod }}</td>
                            <td class="px-5 py-3 text-right font-semibold text-slate-800">{{ invoice.totalCost }}</td>
                        </tr>
                        <tr v-if="!sms.invoices || sms.invoices.length === 0">
                            <td class="px-5 py-6 text-center text-sm text-slate-400" colspan="4">
                                No invoices found for this phone number.
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div v-if="isAakashSMS" class="flex items-center justify-between px-8 py-3"
                style="background-color: #E2E8F0;">
                <div class="text-lg font-semibold text-black">
                    Add New Recharge
                </div>
            </div>
            <div v-if="isAakashSMS" class="rounded-lg border border-slate-200 relative mx-8">
                <div
                    class="absolute badge-dot inline-flex items-center bg-gray-600 border border-slate-500 px-5 py-2 text-xs font-semibold text-white">
                    <span>Phone Number</span>
                </div>
                <div class="flex flex-wrap items-end gap-4 px-6 py-6 mt-4">

                    <div class="flex-1 space-y-3">
                        <div class="space-y-3">
                            <label class="block text-xs font-semibold uppercase text-slate-500"><span class="mr-2">
                                    <Icon icon-name="Numbers" />
                                </span> Phone Number</label>
                            <input type="text" :value="sms.rechargePhone || sms.phone"
                                class="w-full rounded border border-slate-200 bg-white px-4 py-2 text-sm text-slate-700 focus:outline-none"
                                readonly />
                        </div>
                    </div>
                    <div v-if="!showRechargeForm"
                        class="cursor-pointer inline-flex items-center rounded bg-blue-600 px-5 py-2 text-sm font-semibold text-white transition hover:bg-blue-700"
                        @click="showRechargeForm = true">
                        Add New Recharge
                    </div>
                </div>

                <div v-if="showRechargeForm" class="space-y-6 border-t border-slate-200 px-6 py-6">
                    <div class="inline-flex items-center cursor-pointer justify-center rounded-lg border border-slate-600 px-4 py-2 text-sm font-semibold text-slate-600 transition focus:outline-none focus-visible:outline-none focus-visible:ring-0 focus-visible:shadow-none"
                        @click="resetRechargeForm">
                        Back
                    </div>
                    <div class="grid grid-cols-1 gap-6 md:grid-cols-2">
                        <div class="space-y-2">
                            <label class="block text-xs font-semibold uppercase text-slate-500">Credit</label>
                            <input type="number" v-model="creditAmount"
                                class="w-full rounded border border-slate-200 bg-white px-4 py-2 text-sm text-slate-700 focus:outline-none"
                                placeholder="Enter credit amount" />
                        </div>
                        <div class="space-y-2">
                            <label class="block text-xs font-semibold uppercase text-slate-500">Credit Added By</label>
                            <input type="text" :value="loggedInUserName"
                                class="w-full rounded border border-slate-200 bg-slate-100 px-4 py-2 text-sm text-slate-700 focus:outline-none"
                                readonly />
                        </div>
                    </div>
                    <div class="flex flex-wrap items-center gap-3">
                        <div class="cursor-pointer inline-flex items-center rounded bg-blue-600 px-5 py-2 text-sm font-semibold text-white transition hover:bg-blue-700"
                            @click="handleSave">
                            Save
                        </div>
                        <div @click="handleCancel"
                            class="rounded cursor-pointer inline-flex items-center bg-gray-600 border border-slate-500 px-5 py-2 text-xs font-semibold text-white">
                            <span>Cancel</span>
                        </div>
                    </div>
                </div>
            </div>
            <div v-if="isAakashSMS" class="space-y-4 px-8">
                <div class="text-lg font-semibold tracking-wide text-slate-600">
                    Activity Logs
                </div>
                <div class="overflow-hidden">
                    <table class="activity-logs-table min-w-full text-left">
                        <thead class="text-xs font-semibold uppercase tracking-wide text-slate-500"
                            style="background: #E2E8F0;">
                            <tr>
                                <th class="px-5 py-3">Credit Requested By</th>
                                <th class="px-5 py-3">Requested On</th>
                                <th class="px-5 py-3">Credit Amount</th>
                                <th class="px-5 py-3">Added On</th>
                                <th class="px-5 py-3">Added By</th>
                            </tr>
                        </thead>
                        <tbody v-if="loading" class="text-sm text-slate-600">
                            <tr>
                                <td class="px-5 py-6 text-center text-sm text-slate-500" colspan="5">
                                    Loading credit logs...
                                </td>
                            </tr>
                        </tbody>
                        <tbody v-else-if="sms.activityLogs && sms.activityLogs.length" class="text-sm text-slate-600">
                            <tr v-for="log in sms.activityLogs" :key="log.id"
                                class="bg-white border border-slate-200 shadow-sm">
                                <td class="px-5 py-3 text-slate-700">{{ log.requestedBy }}</td>
                                <td class="px-5 py-3">{{ log.requestedOn }}</td>
                                <td class="px-5 py-3">{{ log.creditAmount }}</td>
                                <td class="px-5 py-3">{{ log.addedOn }}</td>
                                <td class="px-5 py-3">{{ log.addedBy }}</td>
                            </tr>
                        </tbody>
                        <tbody v-else>
                            <tr>
                                <td class="px-5 py-6 text-center text-sm text-slate-400" colspan="5">
                                    No activity logs found for this phone number.
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Icon from "../core/Icon.vue";

export default {
    name: "SmsDetail",
    components: {
        Icon
    },
    props: {
        sms: {
            type: Object,
            required: true
        },
        loading: {
            type: Boolean,
            default: false
        },
        tenantId: {
            type: [String, Number],
            required: true
        }
    },
    data() {
        return {
            showRechargeForm: false,
            creditAmount: ""
        };
    },
    computed: {
        isAakashSMS() {
            return this.sms?.provider === "AakashSMS";
        },
        loggedInUserName() {
            return localStorage.getItem("userName") || "-";
        }
    },
    watch: {
        sms: {
            immediate: true,
            handler() {
                this.showRechargeForm = false;
            }
        }
    },
    methods: {
        resetRechargeForm() {
            this.showRechargeForm = false;
            this.creditAmount = "";
        },
        handleSave() {
            const payload = {
                phone_number_code: this.sms.phoneNumberCode || this.sms.phone || "",
                credit: this.creditAmount,
                credit_added_by: this.loggedInUserName,
                tenant_id: this.tenantId
            };
            this.$emit("save-recharge", payload);
        },
        handleCancel() {
            this.resetRechargeForm();
            this.$emit("close");
        }
    }
};
</script>
<style scoped lang="scss">
.badge-dot {
    top: -17px;
    border-radius: 3px;
    left: 20px;
}

.activity-logs-table {
    $table-spacing-x: 0;
    $table-spacing-y: 1rem;


    border-collapse: separate;
    border-spacing: $table-spacing-x $table-spacing-y;
    margin-top: $table-spacing-y * -1;
    margin-bottom: $table-spacing-y * -1;


    thead tr {
        background: #E2E8F0;
        box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.10), 0 1px 2px -1px rgba(0, 0, 0, 0.10);
    }

    tbody tr {
        background: #FEFEFE;
    }

    tbody td {
        border-top: 1px solid #E2E8F0;
        border-bottom: 1px solid #E2E8F0;
        background: #FEFEFE;
    }

    tbody td:first-child {
        border-left: 1px solid #E2E8F0;
        border-radius: 5px 0 0 5px;
    }

    tbody td:last-child {
        border-right: 1px solid #E2E8F0;
        border-radius: 0 5px 5px 0;
    }
}
</style>
